import { useEffect } from "react";
import Userback from "@userback/widget";
import { useAuth } from "@/context/AuthContext";
import { registerUserback } from "@/lib/userback";

const USERBACK_TOKEN = "A-HPHpwi1OPtb1A5cRqE90CpHTU";
const DESKTOP_QUERY = "(min-width: 768px)";

// Userback ist ein globaler Singleton-Widget. Einmal initialisieren und über
// Routen/Logins hinweg bestehen lassen (kein destroy) – sonst gibt es bei
// StrictMode-Doppel-Mounts ein Init/Destroy-Wettrennen, das das Widget tötet.
let ubInstance = null;
let ubLoading = false;

/**
 * Lädt das Userback-Feedback-Widget auf ALLEN Seiten (auch öffentlichen wie
 * Login/Registrierung), nur Desktop (< 768px = Capture-Only-Ansicht bleibt aus).
 * Sobald ein Nutzer eingeloggt ist, wird er für die Zuordnung identifiziert.
 */
export default function UserbackWidget() {
  const { user } = useAuth();

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!window.matchMedia(DESKTOP_QUERY).matches) return;

    const identify = (ub) => {
      if (user && ub && typeof ub.identify === "function") {
        try {
          ub.identify(String(user.id), {
            name: user.company || user.email,
            email: user.email,
          });
        } catch {
          /* ignore */
        }
      }
    };

    if (ubInstance) {
      identify(ubInstance);
      registerUserback(ubInstance);
      return;
    }
    if (ubLoading) return;

    ubLoading = true;
    const options = {};
    if (user) {
      options.user_data = {
        id: String(user.id),
        info: { name: user.company || user.email, email: user.email },
      };
    }
    Userback(USERBACK_TOKEN, options)
      .then((ub) => {
        ubInstance = ub;
        ubLoading = false;
        registerUserback(ub);
        identify(ub);
      })
      .catch((err) => {
        ubLoading = false;
        console.error("Userback init failed:", err);
      });
  }, [user]);

  return null;
}
